/** Phase 20 — stockLocations lesen (Root-Dokument { locations }). */

import {
  getAggregateStockLocations
} from '../infrastructure/storage/domainAggregateStore';
import {
  getEntityStockLocations,
  isEntityStoreAuthorityEnabled
} from '../infrastructure/storage/entityAggregateStore';
import { readBestBusinessMergedPayload } from './sharedCore';

/** @type {Map<string, string[]>} */
const cache = new Map();

export function readStockLocationsFromMergedBlob(businessId) {
  if (!businessId) return [];
  if (isEntityStoreAuthorityEnabled()) {
    const cached = getCachedStockLocationsRead(businessId);
    if (cached) return cached;
  }
  const { parsed } = readBestBusinessMergedPayload(businessId);
  return Array.isArray(parsed?.stockLocations) ? parsed.stockLocations : [];
}

export async function readStockLocationsFromBestSource(businessId) {
  if (!businessId) return [];

  if (isEntityStoreAuthorityEnabled()) {
    try {
      const fromEntity = await getEntityStockLocations(businessId);
      if (fromEntity.length > 0) return fromEntity;
    } catch {
      /* ignore */
    }
  }

  const fromBlob = readStockLocationsFromMergedBlob(businessId);
  if (fromBlob.length > 0) return fromBlob;

  try {
    const fromAggregate = await getAggregateStockLocations(businessId);
    if (fromAggregate.length > 0) return fromAggregate;
  } catch {
    /* ignore */
  }

  try {
    return await getEntityStockLocations(businessId);
  } catch {
    return fromBlob;
  }
}

export async function refreshStockLocationsReadCache(businessId, preloaded) {
  const locations =
    preloaded !== undefined
      ? Array.isArray(preloaded)
        ? preloaded
        : []
      : await readStockLocationsFromBestSource(businessId);
  if (businessId) cache.set(String(businessId), locations);
  return locations;
}

export function getCachedStockLocationsRead(businessId) {
  if (!businessId) return null;
  return cache.get(String(businessId)) ?? null;
}

export function clearStockLocationsReadCache(businessId) {
  if (businessId) cache.delete(String(businessId));
  else cache.clear();
}

export function readStockLocationsSyncForBusiness(businessId) {
  if (!businessId) return [];
  const cached = getCachedStockLocationsRead(businessId);
  if (cached) return cached;
  return readStockLocationsFromMergedBlob(businessId);
}
